// src/components/Token.js
function Token({ data, onClick, isCaregiverScreen }) {
  //console.log('Rendering Token:', data);
  return (
    <div className="token" onClick={onClick}>
      <div className="token-label">{data.label}</div>
      {data.adls && data.adls.length > 0 ? (
        <div className="token-adl">
          {data.adls.map((adl, index) => (
            <span
              key={index}
              className={adl.startsWith('C_') ? 'adl-caregiver' : 'adl-client'}
            >
              {adl}{index < data.adls.length - 1 ? ', ' : ''}
            </span>
          ))}
        </div>
      ) : (
        <div className="token-adl">No ADLs</div>
      )}
    </div>
  );
}

export default Token;